import { ApiError } from '@/lib/api';

import type { ControlledFileKind, VersionStatus } from './types';
import { errorAdvice } from '@/lib/error-advice';

// Textos de los documentos controlados (UX-COPY-01): tipos y estados en palabras, y el
// tamaño legible en el formato de Costa Rica (coma decimal).

const KIND_LABELS: Record<ControlledFileKind, string> = {
  control_cambios: 'Control de cambios',
  editable: 'Editable',
  pdf_vigente: 'PDF',
};

const STATUS_BADGES: Record<VersionStatus, { text: string; className: string }> = {
  vigente: { text: 'Vigente', className: 'b-ok' },
  pendiente_vigencia: { text: 'Pendiente de vigencia', className: 'b-info' },
  obsoleto: { text: 'Obsoleto', className: 'b-mut' },
};

const SIZE = new Intl.NumberFormat('es-CR', { maximumFractionDigits: 1 });
const UNITS = ['B', 'KB', 'MB', 'GB'] as const;

export function fileKindLabel(kind: ControlledFileKind): string {
  return KIND_LABELS[kind];
}

export function versionStatusBadge(status: VersionStatus): { text: string; className: string } {
  return STATUS_BADGES[status];
}

export function fileSizeLabel(bytes: number): string {
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${SIZE.format(value)} ${UNITS[unit] ?? 'B'}`;
}

/** Aviso de una descarga fallida según qué falló (UX-ERR-01: qué pasó y qué hacer). */
export function downloadErrorText(err: unknown, fileName: string): string {
  const status = err instanceof ApiError ? err.status : null;
  if (status === 403) {
    return `No tienes permiso para descargar ${fileName}. Si lo necesitas, pide acceso al Administrador de Calidad.`;
  }
  if (status === 404) {
    return `${fileName} ya no está disponible. Actualiza la página.`;
  }
  return `No se pudo descargar ${fileName}. ${errorAdvice(err)}`;
}
